import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    membersHeading: string;
    shareListsHeading: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Group heading for account members and groups */
            membersHeading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessRowList.membersHeading?c=gy419cl3h20w", defaultMessage: "Members" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Group heading for share lists */
            shareListsHeading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessRowList.shareListsHeading?c=3fijlwewikmm7", defaultMessage: "Share Lists" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
